// PsyPractice — hukuki belgeler / Nederlands.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar — aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir —
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Eenmanszaak";

const OWNER = 'PsyPractice (hierna: het "Platform" of de "Verwerkingsverantwoordelijke")';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Gebruiksvoorwaarden en disclaimer",
    description:
      "Aard en grenzen van de dienst, waarvoor het geen vervanging is, verplichtingen van de Gebruiker en een uitgebreide vrijwaring die alle aansprakelijkheid bij de Gebruiker legt.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Partijen en aanvaarding",
        paras: [
          `Deze Gebruiksvoorwaarden worden aangegaan tussen ${OWNER} en iedere natuurlijke persoon of rechtspersoon die het Platform bezoekt of gebruikt (de "Gebruiker"). Door een account aan te maken, in te loggen of het Platform op enigerlei wijze te gebruiken, bevestigt de Gebruiker deze Voorwaarden te hebben gelezen en begrepen en deze volledig, onvoorwaardelijk te aanvaarden en na te komen. Wie deze Voorwaarden niet aanvaardt, mag het Platform niet gebruiken.`,
        ],
      },
      {
        heading: "2. Aard en grenzen van de dienst",
        bullets: [
          "PsyPractice is AI-ondersteunde SIMULATIEsoftware voor patiëntgesprekken waarmee psychologiestudenten en beginnende clinici hun eigen gespreksoefening in een veilige omgeving uitvoeren en vastleggen.",
          "PsyPractice is GEEN opleidings- of onderwijsdienst; het is een softwaretool waarmee de gebruiker zijn eigen oefening uitvoert en vastlegt. Het Platform biedt geen lessen, curriculum, examens of documenten en verleent geen enkele titel, kwalificatie of bevoegdheid.",
          "De gesimuleerde “patiënt” is geen echte cliënt; de reacties worden door kunstmatige intelligentie gegenereerd, kunnen onjuist, onvolledig, inconsistent of misleidend zijn en pretenderen geen klinische juistheid of waarheid.",
        ],
      },
      {
        heading: "2.1. Waarvoor het Platform geen vervanging is",
        bullets: [
          "Het is GEEN echte therapie of hulpverlening en vervangt geen enkele sessie met een echte cliënt.",
          "Het is GEEN vervanging van klinische supervisie. De feedbackverslagen van de supervisor-AI zijn automatisch gegenereerde tekst; het is geen deskundigenoordeel, geen officiële beoordeling en geen cijfer.",
          "Het is GEEN diagnostisch, screenings- of testinstrument; geen enkele uitkomst van het Platform mag worden gebruikt voor diagnostiek of klinische besluitvorming over een echt persoon.",
          "Het mag NIET worden gebruikt in crisis- of noodsituaties. Bij suïcidale gedachten, gevaar voor zichzelf of anderen of een vergelijkbare noodsituatie: sluit het Platform en neem onmiddellijk contact op met de lokale hulpdiensten of een bevoegde zorginstelling.",
          "Het is GEEN bron van professionele bekwaamheid, registratie, titel of bevoegdheid; de tijd die op het Platform is doorgebracht en de uitkomsten daarvan mogen bij geen enkele instantie worden gepresenteerd als bewijs van kwalificatie.",
        ],
      },
      {
        heading: "3. Verklaringen en verplichtingen van de Gebruiker",
        bullets: [
          "De Gebruiker verplicht zich het Platform uitsluitend binnen wettelijke en ethische grenzen te gebruiken, met het doel de eigen beroepspraktijk te ontwikkelen.",
          "De Gebruiker stemt ermee in GEEN gegevens van ECHTE patiënten/cliënten, identificerende gegevens of bijzondere categorieën van gezondheidsgegevens van welke persoon dan ook in te voeren; alle juridische gevolgen daarvan liggen uitsluitend bij de Gebruiker.",
          "De Gebruiker verplicht zich geen enkele uitkomst van het Platform te gebruiken voor de diagnose, behandeling, interventie of klinische besluitvorming ten aanzien van een echt persoon.",
          "De Gebruiker is als enige verantwoordelijk voor de eigen professionele bekwaamheid, de grenzen van de eigen bevoegdheid en de naleving van de toepasselijke beroeps- en gedragsregels.",
          "De beveiliging van het account, de geheimhouding van het wachtwoord en alle activiteit die onder het account van de Gebruiker plaatsvindt, komen voor rekening van de Gebruiker.",
          "Het account is persoonlijk; de Gebruiker verbindt zich ertoe het niet met anderen te delen en het Platform niet met geautomatiseerde middelen (bots, scripts enz.) te gebruiken. Het gebruik van betaalde abonnementen valt onder een grens voor redelijk gebruik (momenteel 60 sessies per kalendermaand), nader geregeld in de Overeenkomst op afstand.",
        ],
      },
      {
        heading: "4. Alle aansprakelijkheid ligt bij de Gebruiker (vrijwaring)",
        paras: [
          "Het Platform wordt geleverd “AS IS” en “AS AVAILABLE”, zonder enige uitdrukkelijke of impliciete garantie (waaronder ononderbroken werking, foutloosheid, geschiktheid voor een bepaald doel, juistheid of actualiteit).",
          "De Gebruiker aanvaardt en erkent UITSLUITEND en PERSOONLIJK verantwoordelijk te zijn voor alle directe, indirecte, incidentele, bijzondere of gevolgschade (waaronder materiële schade, immateriële schade, schade aan de beroepsreputatie, gegevensverlies, omzetderving en schade toegebracht aan derden) die voortvloeit uit het gebruik of het niet kunnen gebruiken van het Platform, uit het vertrouwen op AI-uitkomsten of uit het op enigerlei wijze toepassen daarvan.",
          "Voor zover het toepasselijke recht dat toestaat, DOET de Gebruiker hierbij onherroepelijk en onvoorwaardelijk — nu en bij voorbaat — AFSTAND van alle aanspraken, vorderingen en rechten op schadevergoeding die hij zou kunnen instellen jegens het Platform en de eigenaren, medewerkers, ontwikkelaars, zakelijke partners en dienstverleners daarvan, met betrekking tot enige schade die hij bij een nadelige uitkomst zou kunnen lijden.",
          "De Gebruiker verplicht zich voorts het Platform volledig te vrijwaren van alle aanspraken, schade, boetes en kosten (waaronder advocaatkosten) indien het Platform door een derde of een instantie wordt aangesproken wegens eigen schuld of nalatigheid van de Gebruiker of wegens gebruik in strijd met deze Voorwaarden.",
        ],
      },
      {
        heading: "5. Beperking van aansprakelijkheid",
        paras: [
          "Onverminderd dwingendrechtelijke bepalingen is de totale wettelijke aansprakelijkheid van het Platform in alle gevallen beperkt tot het bedrag dat de Gebruiker in de 12 maanden voorafgaand aan de gebeurtenis die tot de betreffende aanspraak leidt, daadwerkelijk aan het Platform heeft betaald. Bij kosteloos gebruik bedraagt dit nul.",
        ],
      },
      {
        heading: "6. Intellectuele eigendom, wijziging en beëindiging",
        bullets: [
          "Alle intellectuele-eigendomsrechten op het Platform, de software, het ontwerp, de sjablonen van de patiëntcasussen en de content berusten bij het Platform.",
          "Alle overdraagbare economische intellectuele-eigendomsrechten op content die de Gebruiker op het Platform creëert (waaronder de therapeutberichten die hij schrijft, de sessietranscripten en het daarvan afgeleide materiaal) worden op het moment van creatie geacht exclusief, eeuwigdurend en royaltyvrij aan het Platform te zijn overgedragen; het Platform mag deze content wereldwijd en zonder beperking gebruiken, verveelvoudigen en verwerken voor elk doel, waaronder het exploiteren van de dienst, het genereren van feedback en het verbeteren en doorontwikkelen van het systeem (met inbegrip van verbetering via machine learning). De rechten van de Gebruiker als betrokkene op grond van de gegevensbeschermingswetgeving (AVG (GDPR) / KVKK) worden door deze overdracht niet aangetast en blijven voorbehouden.",
          "Het Platform behoudt zich het recht voor deze Voorwaarden en de omvang van de dienst op elk moment en zonder voorafgaande kennisgeving te wijzigen, op te schorten of te beëindigen.",
          "Bij schending van deze Voorwaarden kan het Platform het account zonder voorafgaande kennisgeving opschorten of sluiten.",
        ],
      },
      {
        heading: "7. Toepasselijk recht en bevoegde rechter",
        paras: [
          "Op deze Voorwaarden is het recht van de Republiek Türkiye van toepassing. Voor geschillen die kunnen ontstaan zijn de rechtbanken en executiekantoren van de Republiek Türkiye bevoegd.",
          "Voor consumenten die in de Europese Unie wonen blijven de bescherming van de dwingendrechtelijke consumentenbepalingen van hun woonland en hun rechten op grond van de AVG (GDPR) voorbehouden; deze rechtskeuze doet aan die dwingende bepalingen niet af.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Privacybeleid",
    description:
      "De AVG (GDPR) als basisstandaard; verwerkte gegevens, rechtsgronden, hosting in de EU, doorgifte naar het buitenland (AI-leverancier) en de KVKK art. 9-bepaling over doorgifte voor gebruikers in Türkiye.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Dit Privacybeleid legt uit hoe persoonsgegevens worden verwerkt binnen het Platform dat wordt geëxploiteerd door ${OWNER}. Als basisstandaard voor gegevensbescherming volgt dit beleid de Algemene verordening gegevensbescherming van de EU (AVG / GDPR / 2016/679); voor gebruikers in Türkiye geldt daarnaast de Turkse wet nr. 6698 inzake de bescherming van persoonsgegevens (KVKK) — in het bijzonder artikel 9 over doorgifte naar het buitenland. De KVKK-informatieverklaring en de Verklaring van uitdrukkelijke toestemming maken integraal deel uit van dit beleid.`,
        ],
      },
      {
        heading: "Verwerkingsverantwoordelijke en hostinglocatie",
        bullets: [
          "Verwerkingsverantwoordelijke: PsyPractice. Verzoeken van betrokkenen worden behandeld via het contactkanaal dat op het Platform is bekendgemaakt (contact-e-mail: info@psycora.com).",
          "Hosting: het Platform en de database worden binnen de Europese Unie gehost — in een datacenter in Nederland (Oracle Cloud). Voor gebruikers in de EU/EER worden gegevens binnen de EU verwerkt en opgeslagen.",
          "De hostingaanbieder treedt uitsluitend op als verwerker, op grond van een gesloten verwerkersovereenkomst (DPA).",
        ],
      },
      {
        heading: "Verzamelde gegevens",
        bullets: [
          "Accountgegevens: naam, e-mailadres, gehasht wachtwoord, abonnements-/plangegevens.",
          "Gebruiksgegevens: aangemaakte sessies, sessietranscripten, gegenereerde patiëntcasussen, feedbackverslagen van de supervisor.",
          "Technische gegevens: sessiegegevens, IP-adres, browser-/taalvoorkeur, logs voor rate limiting en beveiliging.",
        ],
      },
      {
        heading: "Verwerkingsdoeleinden en rechtsgrond (AVG art. 6)",
        bullets: [
          "Uitvoering van een overeenkomst (art. 6 lid 1 onder b): aanmaken van het account, het voeren van sessies, patiëntgeheugen over meerdere sessies, beoordeling door de supervisor, beheer van abonnement en gebruikslimieten.",
          "Gerechtvaardigd belang (art. 6 lid 1 onder f): beveiliging, misbruikpreventie, verbetering van het systeem en foutopsporing.",
          "Wettelijke verplichting (art. 6 lid 1 onder c): bewaring/rapportage die uit wetgeving voortvloeit.",
          "Toestemming (art. 6 lid 1 onder a): verwerking voor analyse en productverbetering die niet strikt noodzakelijk is voor de dienst en, waar vereist, doorgifte buiten de EU/EER.",
        ],
      },
      {
        heading: "Doorgifte naar het buitenland",
        paras: [
          "Omdat de hosting binnen de EU plaatsvindt (Nederland), worden de gegevens van gebruikers in de EU/EER in beginsel binnen de EU verwerkt, zonder doorgifte naar een derde land op die laag. Om AI-antwoorden te genereren worden sessie-inhoud en prompts echter doorgegeven aan de AI-dienstverlener (Anthropic), waarvan de verwerkingsinfrastructuur zich buiten de EU/EER kan bevinden (bijvoorbeeld in de Verenigde Staten).",
          "Dergelijke doorgiften buiten de EU/EER berusten op passende waarborgen op grond van AVG art. 44 e.v. — in het bijzonder de modelcontractbepalingen (SCC's) van de Europese Commissie — en met de leverancier wordt een verwerkersovereenkomst (DPA) gesloten. Het Platform verkoopt GEEN persoonsgegevens voor marketingdoeleinden; gegevens worden niet met derden gedeeld, behalve voor zover strikt noodzakelijk om de dienst te leveren (rechtmatige verzoeken van bevoegde autoriteiten voorbehouden).",
        ],
      },
      {
        heading: "Voor gebruikers in Türkiye — KVKK art. 9 (doorgifte naar het buitenland)",
        paras: [
          "De persoonsgegevens van gebruikers in Türkiye worden buiten Türkiye doorgegeven omdat de hosting in Nederland (EU) plaatsvindt, en kunnen daarnaast voor AI-verwerking aan Anthropic worden doorgegeven. Deze doorgiften vallen onder KVKK art. 9 en berusten op passende waarborgen (het door de Autoriteit gepubliceerde standaardcontract / de verbintenis) of, waar vereist, op uw uitdrukkelijke toestemming. De omvang, de ontvangers en het doel van de doorgifte worden nader beschreven in de KVKK-informatieverklaring en de Verklaring van uitdrukkelijke toestemming.",
        ],
      },
      {
        heading: "Rechten van betrokkenen (AVG art. 15–22)",
        bullets: [
          "Inzage, rectificatie, wissing (‘recht op vergetelheid’) en beperking van de verwerking.",
          "Gegevensoverdraagbaarheid: het ontvangen van de door u verstrekte gegevens in een gestructureerd, gangbaar en machineleesbaar formaat.",
          "Bezwaar: bezwaar maken tegen verwerking op grond van gerechtvaardigd belang en tegen direct marketing.",
          "Rechten met betrekking tot uitsluitend geautomatiseerde individuele besluitvorming/profilering.",
          "Het te allen tijde intrekken van toestemming bij verwerking op basis van toestemming (de intrekking doet geen afbreuk aan de rechtmatigheid van de verwerking tot dat moment).",
          "Het recht een klacht in te dienen bij een toezichthoudende autoriteit: de bevoegde gegevensbeschermingsautoriteit in de EU; in Türkiye de Autoriteit persoonsgegevens (KVKK).",
        ],
      },
      {
        heading: "Bewaring en beveiliging",
        bullets: [
          "Gegevens worden bewaard zolang het verwerkingsdoel dat vereist en gedurende de wettelijk voorgeschreven termijnen; na afloop van die termijn worden ze gewist of geanonimiseerd.",
          "Gevoelige velden (zoals het wachtwoord en de verificatie- en herstelcodes van de Gebruiker) worden versleuteld/gehasht bewaard; toegang verloopt op basis van rechten.",
          "Omdat geen enkele methode van verzending of opslag 100% veilig is, kan absolute veiligheid niet worden gegarandeerd.",
        ],
      },
      {
        heading: "Verbod op gegevens van echte patiënten",
        paras: [
          "Het Platform is simulatiesoftware; het invoeren van persoons-/gezondheidsgegevens van echte cliënten is verboden. Alle aansprakelijkheid die voortvloeit uit het invoeren van gegevens in strijd met dit verbod ligt uitsluitend bij de Gebruiker.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "KVKK-informatieverklaring",
    description:
      "Verwerkingsverantwoordelijke, verwerkingsdoeleinden, rechtsgrond, doorgifte en rechten van betrokkenen op grond van artikel 10 van wet nr. 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Verwerkingsverantwoordelijke",
        paras: [
          `Op grond van artikel 10 van de Turkse wet nr. 6698 inzake de bescherming van persoonsgegevens (“KVKK”) worden uw persoonsgegevens verwerkt door ${OWNER} in de hoedanigheid van Verwerkingsverantwoordelijke, binnen de hieronder beschreven kaders.`,
        ],
      },
      {
        heading: "Verwerkte gegevens en doeleinden",
        bullets: [
          "Identiteit/contact (naam, e-mailadres): aanmaken van het account, authenticatie, communicatie.",
          "Klanttransactie (abonnement, plan, gebruik): levering van de dienst, facturatie, handhaving van limieten.",
          "Transactiebeveiliging (sessie, IP-adres, logs): beveiliging, misbruikpreventie, wettelijke verplichting.",
          "Gebruikerscontent (sessietranscripten, gegenereerde casussen): levering van de softwaredienst en het genereren van feedback.",
          "Lidmaatschap van een cohort van een instelling (cohortkenmerk, lidmaatschapsperiode): wanneer de gebruiker deelneemt aan een cohort van een instelling, de inzage door de docent en het beheer van het cohort.",
        ],
      },
      {
        heading: "Rechtsgrond (art. 5)",
        bullets: [
          "Sluiting/uitvoering van een overeenkomst: gegevens die nodig zijn om de dienst te leveren.",
          "Gerechtvaardigd belang van de verwerkingsverantwoordelijke: beveiliging, fraudepreventie, verbetering van het systeem.",
          "Wettelijke verplichting: bewaring/rapportage die uit wetgeving voortvloeit.",
          "Uitdrukkelijke toestemming: doorgifte naar het buitenland (art. 9) en aanvullende verwerking die niet strikt noodzakelijk is voor de dienst.",
        ],
      },
      {
        heading: "Doorgifte naar het buitenland (art. 9)",
        paras: [
          "Omdat het Platform en de database binnen de Europese Unie worden gehost — in een datacenter in Nederland (Oracle Cloud) — worden de persoonsgegevens van gebruikers in Türkiye buiten Türkiye doorgegeven (naar de EU). Daarnaast kunnen sessie-inhoud en prompts voor het genereren van AI-antwoorden worden doorgegeven aan de AI-dienstverlener (Anthropic), waarvan de verwerkingsinfrastructuur zich buiten de EU/EER kan bevinden (bijvoorbeeld in de Verenigde Staten).",
          "Deze doorgiften naar het buitenland vallen onder KVKK art. 9 en berusten op passende waarborgen — zoals het door de Autoriteit gepubliceerde standaardcontract / de verbintenis — of, waar vereist, op uw uitdrukkelijke toestemming. Met de hosting- en dienstverleners worden verwerkersovereenkomsten (DPA's) gesloten.",
        ],
      },
      {
        heading: "Cohorten van instellingen en inzage door de docent",
        paras: [
          "Als u deelneemt aan een cohort dat door een universiteit, kliniek of vergelijkbare instelling is geopend, kunnen uw sessie-inhoud (transcripten) en supervisieverslagen gedurende de looptijd van het cohort door de docent van dat cohort worden ingezien. Deze inzage betreft uitsluitend uw sessies die aan het cohort zijn gekoppeld en eindigt zodra uw lidmaatschap van het cohort eindigt.",
          "Deze toegang wordt verkregen via een APART scherm voor uitdrukkelijke toestemming dat bij deelname aan het cohort wordt getoond; het maakt geen deel uit van de algemene aanvaarding van het Platform. Geeft u die toestemming niet, dan kunt u niet aan het cohort deelnemen, maar kunt u het Platform onverminderd individueel blijven gebruiken. Intrekking van de toestemming beëindigt uw lidmaatschap van het cohort en laat uw individuele gebruik onverlet.",
        ],
      },
      {
        heading: "Rechten van betrokkenen (art. 11)",
        bullets: [
          "Te vernemen of uw persoonsgegevens worden verwerkt en, zo ja, daarover informatie te verzoeken.",
          "Het doel van de verwerking te vernemen en of de gegevens overeenkomstig dat doel worden gebruikt.",
          "Te weten aan welke derden de gegevens in binnen- of buitenland worden doorgegeven.",
          "Rectificatie te verzoeken van onvolledige/onjuiste verwerking en, indien aan de voorwaarden is voldaan, wissing/vernietiging.",
          "Bezwaar te maken tegen een voor u nadelige uitkomst die uitsluitend uit geautomatiseerde analyse voortvloeit.",
          "Vergoeding te vorderen van schade die door onrechtmatige verwerking is geleden.",
        ],
      },
      {
        heading: "Verzoeken",
        paras: [
          "U kunt verzoeken met betrekking tot uw rechten indienen via het contactkanaal dat de Verwerkingsverantwoordelijke bekend heeft gemaakt. Verzoeken worden afgehandeld binnen de termijnen die de KVKK en de daarop gebaseerde regelgeving voorschrijven.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Verklaring van uitdrukkelijke toestemming",
    description:
      "Los van de informatieverklaring; vrijelijk gegeven toestemming voor doorgifte naar het buitenland en AI-verwerking.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Ik verklaar dat ik de KVKK-informatieverklaring heb gelezen en begrepen, en dat ik vrijelijk, geïnformeerd en uitdrukkelijk toestemming geef voor de hieronder beschreven verwerking. (Op grond van besluit nr. 2018/90 van de KVKK-Autoriteit wordt uitdrukkelijke toestemming los van de informatieplicht verkregen.)",
        ],
      },
      {
        heading: "Verwerking waarvoor toestemming wordt gegeven",
        bullets: [
          "Doorgifte van mijn persoonsgegevens buiten Türkiye en de opslag en verwerking daarvan aldaar, omdat het Platform in de Europese Unie wordt gehost (Nederland / Oracle Cloud) (KVKK art. 9).",
          "Doorgifte en verwerking van mijn sessietranscripten en prompts bij de AI-dienstverlener (Anthropic), waarvan de verwerkingsinfrastructuur zich buiten de EU/EER kan bevinden, met het doel AI-antwoorden te genereren (KVKK art. 9).",
          "Verwerking voor productverbetering en analyse die niet strikt noodzakelijk is om de dienst te leveren.",
          "Het ontvangen van meldingen die verband houden met de dienst.",
        ],
      },
      {
        heading: "Intrekking van de toestemming",
        paras: [
          "Ik begrijp dat ik mijn uitdrukkelijke toestemming te allen tijde kan intrekken; omdat doorgifte naar het buitenland aan de AI-leverancier technisch noodzakelijk is om de dienst te laten werken, aanvaard ik echter dat intrekking van deze toestemming ertoe kan leiden dat ik de betreffende functies of de dienst als geheel niet meer kan gebruiken. De intrekking doet geen afbreuk aan de rechtmatigheid van de verwerking tot de datum van intrekking.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice — see the comment there.
    id: "outreach",
    title: "Informatie over onze zakelijke benadering",
    description:
      "Voor academici en institutionele contactpersonen die een zakelijke benaderingsmail hebben ontvangen: waar de gegevens vandaan komen, waarom ze worden verwerkt, de rechtsgrond en hoe u zich kunt afmelden.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Deze verklaring informeert de ontvangers van zakelijke benaderingsmails die PsyPractice stuurt aan psychologieafdelingen van universiteiten en hun wetenschappelijk personeel, overeenkomstig artikel 10 van de Turkse wet nr. 6698 inzake de bescherming van persoonsgegevens (KVKK) en de Mededeling inzake de procedures en beginselen voor het nakomen van de informatieplicht. Omdat uw persoonsgegevens niet rechtstreeks bij u zijn verkregen, vindt de informatieverstrekking uiterlijk plaats bij het eerste contact; daarom verwijst de benaderingsmail naar deze pagina.",
        ],
      },
      {
        heading: "1. Verwerkingsverantwoordelijke",
        bullets: [
          `Naam: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adres: ${MERCHANT.addressEn}`,
          `Belastingkantoor / nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Verwerkte gegevens en de bron daarvan",
        paras: [
          "De verwerking blijft beperkt tot zakelijke contactgegevens: naam, academische titel, universiteit en afdeling, institutioneel e-mailadres en, voor zover gepubliceerd, institutioneel telefoonnummer.",
          "Deze gegevens zijn niet bij u verzameld, maar samengesteld uit de openbaar gepubliceerde officiële afdelings- en faculteitspagina's van universiteiten. Er worden geen bijzondere categorieën van gegevens verwerkt en privé-e-mailadressen (niet-institutionele adressen) worden niet voor benadering gebruikt.",
        ],
      },
      {
        heading: "3. Doel",
        paras: [
          "Uw gegevens worden verwerkt om een softwaretool te introduceren die is gemaakt voor psychologiestudenten en hun klinische oefening, om uw afdeling uit te nodigen voor een gesprek over een mogelijke pilot of samenwerking, en om de daarbij horende correspondentie te voeren. Ze worden niet voor enig ander doel gebruikt, niet verkocht en niet voor marketingdoeleinden aan derden doorgegeven.",
        ],
      },
      {
        heading: "4. Rechtsgrond",
        paras: [
          "De verwerking berust op het gerechtvaardigd belang van de verwerkingsverantwoordelijke op grond van artikel 5/2-(f) KVKK, voor zover dit geen afbreuk doet aan uw grondrechten en fundamentele vrijheden: er wordt uitsluitend contact opgenomen via een institutioneel adres, uitsluitend over een onderwerp dat rechtstreeks verband houdt met het vakgebied van de ontvanger, en slechts een beperkt aantal keren.",
          "Het enkele feit dat gegevens openbaar op internet beschikbaar zijn, vormt op zichzelf geen rechtsgrond. De Autoriteit persoonsgegevens heeft geoordeeld dat het openbaar zijn van gegevens die gegevens niet voor elk doel bruikbaar maakt en dat de bedoeling en het doel van de openbaarmaking afzonderlijk moeten worden beoordeeld; op artikel 5/2-(d) wordt daarom geen beroep gedaan.",
        ],
      },
      {
        heading: "5. Doorgifte en bewaring",
        paras: [
          "De correspondentie verloopt via een e-mailaanbieder waarvan de infrastructuur zich in het buitenland kan bevinden; dergelijke doorgiften vinden plaats met passende waarborgen op grond van artikel 9 KVKK.",
          "Uw gegevens worden gewist zodra het doel van het contact eindigt of op uw verzoek. Na een verzoek tot verwijdering wordt uitsluitend een strikt beperkte registratie ‘niet benaderen’ bewaard, enkel om te waarborgen dat u niet opnieuw wordt benaderd; die wordt nooit voor benadering gebruikt.",
        ],
      },
      {
        heading: "6. Commerciële elektronische berichten en het recht van weigering",
        paras: [
          `Promotionele berichten vallen onder wet nr. 6563 inzake de regulering van de elektronische handel. U kunt de ontvangst ervan zonder opgaaf van reden weigeren; weigeringen worden uiterlijk binnen drie werkdagen verwerkt, waarna geen promotioneel bericht meer wordt verzonden. Een antwoord op de ontvangen e-mail, of een bericht aan ${MERCHANT.email}, volstaat.`,
        ],
      },
      {
        heading: "7. Uw rechten",
        paras: [
          "Op grond van artikel 11 KVKK hebt u het recht te vernemen of uw persoonsgegevens worden verwerkt, daarover informatie te verzoeken, het doel van de verwerking te vernemen en of de gegevens overeenkomstig dat doel worden gebruikt, te weten aan welke derden ze in Türkiye of in het buitenland worden doorgegeven, rectificatie te verzoeken van onvolledige of onjuiste gegevens, wissing of vernietiging te verzoeken, te verzoeken dat deze handelingen aan derden worden meegedeeld, bezwaar te maken tegen een voor u nadelige uitkomst die uitsluitend door geautomatiseerde analyse tot stand komt, en vergoeding te vorderen van geleden schade.",
          `Verzoeken kunnen worden gestuurd naar ${MERCHANT.email} en worden uiterlijk binnen dertig dagen beantwoord. U behoudt daarnaast het recht een klacht in te dienen bij de Autoriteit persoonsgegevens.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Cookiebeleid",
    description: "Gebruikte soorten cookies, de doeleinden daarvan en het beheer van voorkeuren.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Het Platform gebruikt cookies en vergelijkbare technieken voor lokale opslag (localStorage) om uw sessie in stand te houden en uw voorkeuren te onthouden.",
        ],
      },
      {
        heading: "Gebruikte technieken",
        bullets: [
          "Strikt noodzakelijk: sessie-/authenticatietoken, beveiliging. Zonder deze werkt de dienst niet.",
          "Functioneel: taal-/localevoorkeur (NEXT_LOCALE), interfacevoorkeuren (zoals het thema).",
          "Prestaties/beveiliging: technische logs voor rate limiting en het opsporen van misbruik.",
        ],
      },
      {
        heading: "Beheer van voorkeuren",
        paras: [
          "U kunt cookies in uw browser verwijderen of blokkeren; het blokkeren van strikt noodzakelijke cookies maakt inloggen en de kernfunctionaliteit echter onmogelijk. In lijn met de beginselen van de AVG (GDPR) / ePrivacy en de KVKK-cookiegids worden niet-noodzakelijke cookies uitsluitend gebruikt op basis van uw uitdrukkelijke voorkeur/toestemming.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Over ons",
    description:
      "Het doel van PsyPractice, de dienst die wordt aangeboden en de contactgegevens van de verkoper.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice is een AI-ondersteund platform voor patiëntsimulatie en klinische vaardigheden, gemaakt voor psychologiestudenten en pas afgestudeerde, beginnende clinici. Gebruikers voeren tekstsessies met een gesimuleerde patiënt; aan het einde van elke sessie beoordeelt een supervisor-AI het gesprek en schrijft een feedbackverslag gericht op ontwikkeling. De patiënt-AI draagt de therapeutische relatie sessie na sessie verder dankzij geheugen over meerdere sessies.",
        ],
      },
      {
        heading: "Onze missie",
        paras: [
          "Ons doel is toekomstige professionals in de geestelijke gezondheidszorg een veilige, herhaalbare omgeving te bieden om gespreksvaardigheden te oefenen zonder enig risico echte cliënten te schaden. PsyPractice is GEEN opleidings- of onderwijsdienst; het is een softwaretool waarmee de gebruiker zijn eigen oefening uitvoert en vastlegt. Het is geen echte therapie of hulpverlening, het vervangt geen klinische supervisie, het is geen diagnostisch of testinstrument en het mag niet worden gebruikt in crisis- of noodsituaties.",
        ],
      },
      {
        heading: "Wat wij bieden",
        bullets: [
          "Simulatie van tekstsessies met uiteenlopende patiëntprofielen die uit klinische literatuur zijn samengesteld.",
          "Automatische beoordelingsverslagen van de supervisor na elke sessie.",
          "Een model van een ‘levende patiënt’ met geheugen over meerdere sessies, waardoor de therapeutische relatie zich in de tijd ontwikkelt.",
          "Het genereren van eigen patiënten, waarmee studenten hun eigen AI-casussen kunnen maken.",
          "Voortgangsmetingen die de ontwikkeling van microvaardigheden volgen.",
        ],
      },
      {
        heading: "Gegevens van de verkoper / onderneming",
        bullets: [
          `Handelsnaam: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adres: ${MERCHANT.addressEn}`,
          `Belastingkantoor / nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Overeenkomst op afstand",
    description:
      "Verkoper, koper, dienst, prijs, betaling, uitvoering en herroepingsvoorwaarden op grond van de Turkse wet nr. 6502 en de Verordening inzake overeenkomsten op afstand.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Partijen",
        bullets: [
          `VERKOPER: ${MERCHANT.legalName} (${OWNER_TYPE}). Adres: ${MERCHANT.addressEn}. Belastingkantoor/nr.: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-mail: ${MERCHANT.email}.`,
          "KOPER: de natuurlijke persoon of rechtspersoon die op het Platform een account aanmaakt en een betaald abonnement afsluit (de \"Koper\").",
        ],
      },
      {
        heading: "2. Onderwerp van de overeenkomst",
        paras: [
          "Deze Overeenkomst heeft tot doel de rechten en verplichtingen van partijen vast te leggen, overeenkomstig de Turkse wet nr. 6502 inzake consumentenbescherming en de Verordening inzake overeenkomsten op afstand, met betrekking tot de verkoop en de uitvoering van het digitale dienstabonnement dat de Koper langs elektronische weg via het Platform afsluit en waarvan de kenmerken en de verkoopprijs hieronder zijn vermeld.",
        ],
      },
      {
        heading: "3. Aard van de dienst en prijs",
        bullets: [
          "De verkochte dienst bestaat uit de AI-ondersteunde functies voor patiëntsimulatie die worden aangeboden onder een betaald abonnement van de PsyPractice-software (een digitale dienst / een gebruiksrecht op de software).",
          "PsyPractice is GEEN opleidings- of onderwijsdienst; het is een softwaretool waarmee de gebruiker zijn eigen oefening uitvoert en vastlegt. De abonnementsprijs is de tegenprestatie voor toegang tot die software; het is geen vergoeding voor lessen, curriculum, examens, advies of enig document.",
          "De inhoud van het abonnement, de looptijd (maandelijks, een periode van 4 maanden of jaarlijks) en de actuele prijs worden op het moment van aankoop duidelijk weergegeven op de prijs-/betaalpagina van het Platform; het totaalbedrag inclusief belastingen wordt vóór de betaling aan de Koper meegedeeld.",
          "Prijzen gelden in de valuta die op het Platform wordt getoond; tenzij het abonnement wordt opgezegd, wordt het aan het einde van de gekozen looptijd automatisch tegen dezelfde prijs verlengd.",
          "Bij abonnementen die als „onbeperkte sessies” worden aangeboden, valt het gebruik onder een grens voor redelijk gebruik (momenteel 60 sessies per kalendermaand). Is de grens bereikt, dan kunnen vanaf de eerste dag van de volgende kalendermaand weer nieuwe sessies worden gestart; dit geeft geen recht op prijsverlaging of terugbetaling. De grens dient om het delen van accounts en geautomatiseerd gebruik te voorkomen, en de Verkoper wijzigt haar niet ten nadele van de Koper tijdens een betaalde abonnementsperiode.",
        ],
      },
      {
        heading: "4. Betaling",
        paras: [
          "Betalingen worden veilig per credit- of debetkaart geïncasseerd via de vergunde betaalinstelling iyzico. Kaartgegevens worden niet door de Verkoper bewaard; de betaling verloopt via de beveiligde systemen van iyzico. Bij terugkerende (abonnements)betalingen wordt het bedrag bij elke verlengingsperiode automatisch afgeschreven van de kaart die de Koper heeft goedgekeurd.",
        ],
      },
      {
        heading: "5. Uitvoering en levering",
        paras: [
          "De dienst is digitaal en kent geen fysieke levering. Zodra de betaling is bevestigd, worden de abonnementsfuncties onmiddellijk in het account van de Koper beschikbaar gesteld. De uitvoering vindt langs elektronische weg plaats door gedurende de gehele abonnementsperiode ononderbroken toegang te bieden.",
        ],
      },
      {
        heading: "6. Herroepingsrecht en de uitzondering daarop",
        bullets: [
          "Op grond van artikel 15/1-(ğ) van de Verordening inzake overeenkomsten op afstand kan het herroepingsrecht niet worden uitgeoefend voor niet-stoffelijke (digitale) goederen/diensten die onmiddellijk langs elektronische weg worden uitgevoerd, wanneer met de uitvoering met toestemming van de Koper is begonnen.",
          "De Koper erkent bij de aankoop dat de dienst onmiddellijk wordt uitgevoerd en dat er daarom geen herroepingsrecht bestaat. De Koper kan het abonnement op elk moment opzeggen om verlenging te stoppen; de opzegging gaat in aan het einde van de lopende betaalde periode.",
          "Voor uitgebreide restitutievoorwaarden, zie \"Voorwaarden voor levering en restitutie\".",
        ],
      },
      {
        heading: "7. Geschillen en inwerkingtreding",
        paras: [
          "Bij een geschil kan de Koper zich binnen de door het Ministerie van Handel bekendgemaakte geldelijke grenzen wenden tot de Arbitragecommissie voor consumentengeschillen of de consumentenrechter van zijn woonplaats. Deze Overeenkomst komt tot stand en treedt in werking op het moment dat de Koper deze langs elektronische weg goedkeurt.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Voorwaarden voor levering en restitutie",
    description:
      "Levering van de digitale dienst, opzegging van het abonnement, de uitzondering op het herroepingsrecht en de restitutievoorwaarden.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Levering (digitale dienst)",
        bullets: [
          "PsyPractice is een volledig digitale dienst; er is geen verzending van een fysiek product en geen bezorging per koerier.",
          "Zodra de betaling is bevestigd, worden de abonnementsfuncties automatisch en onmiddellijk in het account van de Koper geactiveerd; er geldt geen afzonderlijke levertijd en geen leveringskosten.",
          "De dienst is toegankelijk via de webbrowser van elk apparaat met internetverbinding.",
        ],
      },
      {
        heading: "Opzegging van het abonnement",
        bullets: [
          "De Koper kan het abonnement op elk moment opzeggen in de accountinstellingen. De opzegging gaat in aan het einde van de lopende betaalde periode en stopt de volgende automatische verlenging.",
          "Na opzegging blijft de toegang tot de dienst bestaan voor de rest van de betaalde periode.",
        ],
      },
      {
        heading: "Herroepingsrecht en restitutie",
        bullets: [
          "Omdat het gaat om een digitale dienst die met toestemming van de Koper onmiddellijk wordt uitgevoerd, ontstaat op grond van artikel 15/1-(ğ) van de Verordening inzake overeenkomsten op afstand in beginsel geen herroepingsrecht en daarmee geen recht op restitutie.",
          "Bij een duidelijk gebrek, zoals een onjuiste/dubbele afschrijving, het om technische redenen volledig niet kunnen bereiken van de dienst of een vergelijkbare situatie, kan de Koper binnen een redelijke termijn na de betaaldatum contact opnemen met de Verkoper en om restitutie verzoeken.",
          `Restitutieverzoeken worden gestuurd naar ${MERCHANT.email}; goedgekeurde restituties worden via de infrastructuur van iyzico in beginsel binnen 14 dagen teruggestort op de kaart waarmee is betaald. De termijn kan variëren afhankelijk van de verwerkingstijd van de bank.`,
        ],
      },
      {
        heading: "Contact",
        paras: [
          `Voor alle vragen over levering, opzegging en restitutie: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
